import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/work-reports/_layout/'
)({ component: () => null });
